import React from "react";
import { EaseModal } from "../../../../../libs/EaseModal";
import { Text1 } from "../../../../../styles";
import { VendorInvoiceForm } from "../../Forms/VendorInvoice";

const VendorInvoiceModal = (props) => {
  const renderTitle = () => {
    return (
      <Text1 className="d-block mb-4" strong>
        {`${props.vendorInvoice.is_edit ? "Update" : "Create"} Invoice`}
      </Text1>
    );
  };

  return (
    <EaseModal
      width={750}
      title={false}
      visible={props.visible}
      onCancel={props.toggleVendorInvoiceModal}
      centered
      hideFooter
      destroyOnClose
    >
      {renderTitle()}
      <VendorInvoiceForm
        vendorInvoice={props.vendorInvoice}
        onInvoiceSave={props.onInvoiceSave}
        loading={props.loading}
      />
    </EaseModal>
  );
};

VendorInvoiceModal.defaultProps = {
  vendorInvoice: {},
};

export { VendorInvoiceModal };
